"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM = exports.API_CALL_ORIGIN = exports.TIERS = exports.APP_UI = exports.CONFIG_HIVER = exports.REFETCH_CHECK_DELAY = exports.INITIAL_RETRY_DELAY = exports.MAX_BACKOFF_LIMIT = exports.MAX_CONFLICT_RETRY_DELAY = exports.MAX_RETRY_DELAY = exports.GET_METHOD = void 0;
exports.GET_METHOD = 'GET';
exports.MAX_RETRY_DELAY = 180000;
exports.MAX_CONFLICT_RETRY_DELAY = 63000;
exports.MAX_BACKOFF_LIMIT = 8000;
exports.INITIAL_RETRY_DELAY = 1000;
exports.REFETCH_CHECK_DELAY = 1680000;
exports.CONFIG_HIVER = {
    getToken: false,
    fetchCsrfToken: function () { return ''; },
    isHiverApiDomain: true,
};
exports.APP_UI = {
    COLLAB_SPACE: 'collab-space',
    DEFAULT: 'default',
};
exports.TIERS = {
    DEV: 'dev',
    SIT: 'sit',
    PROD: 'production',
};
exports.API_CALL_ORIGIN = {
    API_RETRY: 'Api Retry',
};
var PLATFORM;
(function (PLATFORM) {
    PLATFORM[PLATFORM["WEB"] = 0] = "WEB";
    PLATFORM[PLATFORM["MOBILE"] = 1] = "MOBILE";
})(PLATFORM = exports.PLATFORM || (exports.PLATFORM = {}));
//# sourceMappingURL=index.js.map